import { useMemo, useState } from 'react';
import { FormStateContext } from './FormStateContext';
import type { IFormSateProvider } from './formSateProvider.types';

export const FormStateProvider = (props: IFormSateProvider) => {
  const [isFormValid, setIsFormValid] = useState(false);

  const contextValue = useMemo(() => {
    return {
      isFormValid,
      setIsFormValid,
    };
  }, [isFormValid]);

  return (
    <FormStateContext.Provider value={contextValue}>{props.children}</FormStateContext.Provider>
  );
};
